import { c as _c } from "react/compiler-runtime";
import type { Thing } from 'schema-dts';
import { MIME_TYPE } from '@libs/core';
import type { JsonLdProps } from './types';
export function JsonLd(t0) {
  const $ = _c(10);
  let json;
  let props;
  if ($[0] !== t0) {
    ({
      json,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = json;
    $[2] = props;
  } else {
    json = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== json) {
    t1 = JSON.stringify(json);
    $[3] = json;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      __html: t1
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <script {...props} type={MIME_TYPE.jsonld} dangerouslySetInnerHTML={t2} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}